import { createMutationHook } from '@/common/hooks/typedHookFactory';
import { QueryKeys } from '@/common/queryKeys';
import { graphql } from '@/generated/graphql';

const DELETE_USER_DEPARTMENTS = graphql(`
  mutation DeleteUserDepartments($userId: String!) {
    delete_departments_users(where: { userId: { _eq: $userId } }) {
      affected_rows
    }
  }
`);

const INSERT_USER_DEPARTMENTS = graphql(`
  mutation InsertUserDepartments($objects: [departments_users_insert_input!]!) {
    insert_departments_users(objects: $objects) {
      affected_rows
      returning {
        id
        departmentId
        userId
      }
    }
  }
`);

export const useDeleteUserDepartments = createMutationHook(DELETE_USER_DEPARTMENTS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_USERS],
    },
    {
      queryKey: () => [QueryKeys.GET_CURRENT_USER_DEPARTMENTS],
    },
  ],
  errorMessage: 'Error deleting user departments',
});

export const useInsertUserDepartments = createMutationHook(INSERT_USER_DEPARTMENTS, {
  invalidateQueries: [
    {
      queryKey: () => [QueryKeys.GET_USERS],
    },
    {
      queryKey: () => [QueryKeys.GET_CURRENT_USER_DEPARTMENTS],
    },
  ],
  errorMessage: 'Error inserting user departments',
});
